import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Link } from "@mui/material";

import { monoFontFamily } from "../../theme/tokens";

export interface PayeeCellProps {
  /** Payee or organisation name (shown at weight 500). */
  name: React.ReactNode;
  /** Identifier shown under the name in small monospace text; hidden when empty. */
  id?: React.ReactNode;
  /** Route for the name link, e.g. `/payees/detail/${payee.id}`. */
  to?: string;
}

/** Two-line table cell: payee name over its id; the name links to `to` when given. */
export function PayeeCell({ name, id, to }: PayeeCellProps) {
  const hasId = id !== undefined && id !== null && id !== "";
  return (
    <Box sx={{ display: "grid", minWidth: 0, lineHeight: 1.35 }}>
      {to ? (
        <Link
          component={RouterLink}
          to={to}
          underline="hover"
          sx={{
            fontWeight: 500,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </Link>
      ) : (
        <Box
          component="span"
          sx={{
            fontWeight: 500,
            color: "text.primary",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </Box>
      )}
      {hasId && (
        <Box
          component="span"
          sx={{
            fontFamily: monoFontFamily,
            fontSize: "0.75rem",
            color: "text.secondary",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {id}
        </Box>
      )}
    </Box>
  );
}

export default PayeeCell;
